import { useMemo, useState } from "react";
import checkCloseTableContext, {
  CheckTableType,
} from "./checkCloseTableContext";

const CheckCloseTableProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const checkTableFilterString = localStorage.getItem("closeCheckTableFilter");

  let InitialCheckTableFilterState = {
    identifier: "time",
    page: 0,
    sortingType: "desc",
  };

  if (checkTableFilterString !== null) {
    const { identifier, page, sortingType }: CheckTableType = JSON.parse(
      checkTableFilterString
    );

    InitialCheckTableFilterState = {
      identifier,
      page: Number(page),
      sortingType,
    };
  }

  const [checkCloseTableState, checkCloseTableSetState] =
    useState<CheckTableType>(InitialCheckTableFilterState);

  const stateValue = useMemo(
    () => [{ checkCloseTableState, checkCloseTableSetState }],
    [checkCloseTableState, checkCloseTableSetState]
  );

  return (
    <checkCloseTableContext.Provider value={stateValue}>
      {children}
    </checkCloseTableContext.Provider>
  );
};

export default CheckCloseTableProvider;
